// extracted by mini-css-extract-plugin
export default {"labelWrapper":"label-module--label-wrapper--b6664"};